import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import getAccessTokenRefreshToken from './api/getAccessTokenRefreshToken';
import getAccessTokenAuthorizationCode from './api/getAccessTokenAuthorizationCode';
import getAuthCodeInfo from './api/getAuthCodeInfo';
var tokenState = {
  refreshToken: '',
  expiryDate: undefined,
  accessToken: ''
};
Object.seal(tokenState);

function persistState(token) {
  tokenState.accessToken = token.access_token;
  var currentTime = new Date();
  currentTime.setSeconds(token.expires_in);
  tokenState.expiryDate = currentTime.getTime();
}

var getNewToken = function getNewToken(clientConfig, authServerConfig) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var clientId, _token, codeInfo, token;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            clientId = clientConfig.clientId;

            if (!tokenState.refreshToken) {
              _context.next = 7;
              break;
            }

            _context.next = 4;
            return getAccessTokenRefreshToken({
              clientId: clientId,
              refreshToken: tokenState.refreshToken
            }, authServerConfig);

          case 4:
            _token = _context.sent;
            persistState(_token);
            return _context.abrupt("return", _token);

          case 7:
            _context.next = 9;
            return getAuthCodeInfo(clientConfig, authServerConfig);

          case 9:
            codeInfo = _context.sent;
            _context.next = 12;
            return getAccessTokenAuthorizationCode(Object.assign({
              clientId: clientId
            }, codeInfo), authServerConfig);

          case 12:
            token = _context.sent;
            persistState(token);
            return _context.abrupt("return", token);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

export { getNewToken, tokenState };